import React from "react";
import { useNavigate, useOutletContext } from "react-router";
import { toast } from "react-toastify";

const OrderSummary = ({ data = [], selectionDelete }) => {
  const navigate = useNavigate();
  const { url } = useOutletContext();

  const totalPrice = data.reduce((total, group) => {
    return (
      total +
      group.products.reduce((sum, product) => {
        const { productPrice = 0, quantity = 1, options = [] } = product;
        const optionTotal = options.reduce(
          (optSum, opt) => optSum + (opt.price ?? 0) * (opt.qty ?? 1),
          0,
        );
        return sum + (productPrice + optionTotal) * quantity;
      }, 0)
    );
  }, 0);

  const deliveryFee = 3000;
  const totalPayable = totalPrice + deliveryFee;

  const handleOrder = () => {
    const selectedGrouped = data
      .map((group) => {
        const selectedProducts = group.products.filter((p) => p.checked);
        if (selectedProducts.length === 0) return null;
        return {
          cmpnyNo: group.cmpnyNo,
          cmpnyNm: group.cmpnyNm,
          products: selectedProducts,
        };
      })
      .filter(Boolean);

    if (selectedGrouped.length === 0) {
      toast.error("주문할 상품을 선택해주세요.");
      return;
    }

    navigate(`/shop/mypage/order`, {
      state: { items: selectedGrouped },
    });
  };

  return (
    <div className="orderSummary">
      <div className="left">
        <div className="actions">
          <button onClick={() => selectionDelete()}>선택상품 삭제</button>
          <button onClick={() => selectionDelete(true)}>장바구니 비우기</button>
        </div>
        <ul>
          {/* <li>장바구니에 담긴 상품은 30일 동안 보관됩니다.</li> */}
          <li>자세한 구매 내역은 주문/배송 조회에서 확인 가능합니다.</li>
        </ul>
      </div>
      <div className="right">
        <div>
          <span>상품금액</span>
          <span>{formatNumber(totalPrice)}원</span>
        </div>
        <div>
          <span>배송비</span>
          <span>+ {formatNumber(deliveryFee)}원</span>
        </div>
        <div>
          <span>결제 예정 금액</span>
          <span>{formatNumber(totalPayable)}원</span>
        </div>
        <button className="submit" onClick={handleOrder}>
          주문하기
        </button>
      </div>
    </div>
  );
};

export default OrderSummary;
